import {Injectable} from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EMPTY} from "rxjs/internal/observable/empty";
import {LoadingService} from './loading.service';
import {AlertMessage, AlertService} from './alert.service';
import {UtilService} from './util.service';
import {LoggerService} from './logger.service';
import {AppStateService} from "./taker/appState.service";
import {PollUtilService} from "./taker/pollUtil.service";
import {WebUtilService} from "./webUtil.service";

// https://angular.io/guide/http
// advanced https://www.npmjs.com/package/ng-http-interceptor
// some interesting https://stackoverflow.com/questions/46019771/catching-errors-in-angular-httpclient?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa

@Injectable()
export class AppInterceptor implements HttpInterceptor {

    constructor(private loadingService: LoadingService,
                private appStateService: AppStateService,
                private pollUtilService: PollUtilService,
                private webUtilService: WebUtilService,
                private alertService: AlertService,
                private utilService: UtilService,
                private logger: LoggerService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.loadingService.emit(true);

        const ret = next.handle(req)
            .map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // do stuff with response if you want
                    this.loadingService.emit(false);
                }
                return event;
            })
            .catch((err: HttpErrorResponse): Observable<HttpEvent<any>> => {
                this.loadingService.emit(false);

                let html = '';
                let loginUrl = null;
                if (err.status === 403/*Access Denied*/ || err.status === 0/*not logged in (CAS)*/) {

                    loginUrl = this.calcLoginUrl();
                    if (loginUrl) {
                        html = `<span>Check your access roles or try to login pressing <b>'Login' button</b> that may resolve the issue.</span>`;
                    }
                }

                const ret = this.alertService.emit(new AlertMessage(this.utilService.httpError(err), 'error', html, loginUrl ? 'Login' : null));
                if (loginUrl && ret) {
                    ret.then((result) => {
                        if (result.value) {
                            // pressed login
                            this.webUtilService.redirect(loginUrl);
                        }
                    });
                }
                return EMPTY;
            });

        return ret;

    }

    private calcLoginUrl() {

        let loginUrl = null;

        const currentUrl = this.webUtilService.getCurrentUrl();
        // FIXME: is config available, how?
        const configResponse = this.appStateService.getConfig();
        const userRelatedData = this.pollUtilService.calcUserRelatedData(configResponse);

        loginUrl = userRelatedData.loginUrl + currentUrl;

        return loginUrl;

    }
}
